import { ArrowPointDown, ArrowPointUp } from "assets/icons/Common";
import { Col, Row } from "components/primitives";
import { DynamicIcon } from "components/primitives";
import { FC, useState } from "react";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

import { DropZoneConfig, WellbeingCheckState } from "./WellbeingCheck";

interface DropdownInfo {}

interface ZoneProps {
  label: string;
  expanded: boolean;
  onClicked: (label: string) => void;
  names: string[];
}

const ExpandableZone: FC<ZoneProps> = ({ label, expanded, onClicked, names }) => {
  const clicked = () => {
    onClicked(label);
  };

  return (
    <Col>
      <GroupHeader onClick={clicked}>
        <ColorDot color={DropZoneConfig[label].color} />
        {DropZoneConfig[label].label} ({names.length})
        <DropIcon Icon={expanded ? ArrowPointUp : ArrowPointDown} />
      </GroupHeader>
      <NameList height={expanded ? `${names.length * 2}em` : "0"}>
        {names.map((name, index) => (
          <p key={index}>{name}</p>
        ))}
      </NameList>
    </Col>
  );
};

export const RegulationZoneSetting: WidgetSettingFC<any, DropdownInfo, WellbeingCheckState> = ({
  data,
  setData,
  info,
  state: { droppedNames },
}) => {
  const [expandedZones, setExpandedZones] = useState<string[]>([]);

  const onZoneClicked = (key: string) => {
    const newExpandedZones = [...expandedZones];
    const index = newExpandedZones.indexOf(key);
    if (index >= 0) {
      newExpandedZones.splice(index, 1);
    } else if (Object.keys(droppedNames[key]).length > 0) {
      newExpandedZones.push(key);
    }
    setExpandedZones(newExpandedZones);
  };

  return (
    <OuterContainer>
      <p>Today's Check-in</p>
      <InnerContainer>
        {Object.keys(droppedNames).map((key) => (
          <ExpandableZone
            key={key}
            label={key}
            expanded={expandedZones.includes(key)}
            onClicked={onZoneClicked}
            names={Object.values(droppedNames[key])}
          />
        ))}
      </InnerContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  margin-bottom: 35px;

  p {
    font-weight: 600;
    margin-bottom: 5px;
    font-size: 12pt;
  }
`;

const InnerContainer = styled(Col)`
  gap: 15px;
`;

const GroupHeader = styled(Row)`
  width: 100%;
  height: 50px;
  border-radius: 5px;
  box-shadow: 0px 0px 6px 0px;
  padding: 3px 10px;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  background-color: white;

  &:hover {
    filter: brightness(95%);
  }
`;

const ColorDot = styled.div<{ color: string }>`
  border-radius: 50%;
  background-color: ${(props) => props.color};
  height: 50%;
  aspect-ratio: 1;
`;

const DropIcon = styled(DynamicIcon)`
  margin-left: auto;
  height: 40%;
  color: var(--primary);
`;

const NameList = styled.div<{ height: string }>`
  transition: all 0.5s ease;
  height: ${(props) => props.height};
  overflow: hidden;

  p {
    margin: 5px;
    line-height: 1.4;
  }
`;
